import React from "react";

/**
 * Renders a Product Type's `field_schema` as dynamic form inputs.
 * Used by both ProductForm (Configuración Financiera) and — in a future
 * sprint — by Order item editors, so logic stays in one place.
 *
 * Props:
 *  - schema: [{ key, label, type, options[], unit, required, order }]
 *  - values: { [key]: any }
 *  - onChange: (key, value) => void
 *  - testIdPrefix: string, e.g. "financial-product-cf"
 */
export default function DynamicFieldInputs({ schema, values, onChange, testIdPrefix = "cf" }) {
  if (!schema || schema.length === 0) return null;

  return (
    <div className="space-y-3 border-l-2 border-[var(--border)] pl-4">
      <div className="label-overline">Campos del tipo</div>
      {schema.map((f) => {
        const v = values?.[f.key] ?? "";
        const tid = `${testIdPrefix}-${f.key}`;
        return (
          <div key={f.key}>
            <label className="block text-xs font-mono-tech text-[var(--text-secondary)] mb-1">
              {f.label}
              {f.required ? <span className="text-[var(--alert-overdue)] ml-1">*</span> : null}
              {f.unit ? <span className="opacity-60"> ({f.unit})</span> : null}
            </label>
            {f.type === "text" && (
              <input
                data-testid={tid}
                value={v}
                onChange={(e) => onChange(f.key, e.target.value)}
                className="w-full border border-[var(--border)] px-3 py-2 font-display text-sm"
              />
            )}
            {f.type === "number" && (
              <input
                data-testid={tid}
                value={v}
                onChange={(e) => onChange(f.key, e.target.value)}
                type="number"
                step="0.01"
                inputMode="decimal"
                className="w-full border border-[var(--border)] px-3 py-2 font-mono-tech text-sm tabular-nums"
              />
            )}
            {f.type === "select" && (
              <select
                data-testid={tid}
                value={v}
                onChange={(e) => onChange(f.key, e.target.value)}
                className="w-full border border-[var(--border)] px-3 py-2 font-display text-sm bg-white"
              >
                <option value="">—</option>
                {f.options.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            )}
          </div>
        );
      })}
    </div>
  );
}
